import * as z from "zod/v4";

export const updateFulfillmentPromiseDays = {
  name: "updateFulfillmentPromiseDays" as const,
  input: z.object({ fulfillmentPromiseDays: z.number().min(0).max(30) }),
  output: z.object({ success: z.boolean() }),
};
